import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Button } from "@opensea/next-ui-kit";
import { Tooltip } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { useCollectionOffers } from "@/components/offers/use-collection-offers";
import { useIsMultiTraitOfferEnabled } from "@/hooks/use-flags";
import { useCollectionItemsFilters } from "../use-collection-items-filters";
import { CollectionItemsMakeOfferButtonFragment } from "./CollectionItemsMakeOfferButton.fragment";
import { useTraitOfferValidation } from "./use-trait-offer-validation";
export function CollectionItemsMakeOfferButton(t0) {
  const $ = _c(38);
  const {
    collection: collectionKey,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "secondary" : t1;
  let t2;
  if ($[0] !== collectionKey) {
    t2 = readFragment(CollectionItemsMakeOfferButtonFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const collection = t2;
  const isMultiTraitOfferEnabled = useIsMultiTraitOfferEnabled();
  const t = useTranslations("CollectionItemsMakeOfferButton");
  const {
    traits
  } = useCollectionItemsFilters();
  const singleTraitSelected = traits.length === 1 && traits[0].values.length === 1;
  const {
    isValid,
    shouldShowDisabled,
    disabledReason,
    isTraitOffer: isTraitOfferValidation
  } = useTraitOfferValidation(traits, Boolean(collection?.traitOffersEnabled && isMultiTraitOfferEnabled));
  let offerCriteria;
  if ($[2] !== isMultiTraitOfferEnabled || $[3] !== isValid || $[4] !== singleTraitSelected || $[5] !== traits) {
    offerCriteria = {};
    if (singleTraitSelected) {
      let t3;
      if ($[7] !== traits[0].traitType || $[8] !== traits[0].values[0]) {
        t3 = {
          traitType: traits[0].traitType,
          value: traits[0].values[0]
        };
        $[7] = traits[0].traitType;
        $[8] = traits[0].values[0];
        $[9] = t3;
      } else {
        t3 = $[9];
      }
      offerCriteria.trait = t3;
    } else {
      if (isMultiTraitOfferEnabled && isValid) {
        let t3;
        if ($[10] !== traits) {
          t3 = traits.map(_temp);
          $[10] = traits;
          $[11] = t3;
        } else {
          t3 = $[11];
        }
        offerCriteria.traits = t3;
      }
    }
    $[2] = isMultiTraitOfferEnabled;
    $[3] = isValid;
    $[4] = singleTraitSelected;
    $[5] = traits;
    $[6] = offerCriteria;
  } else {
    offerCriteria = $[6];
  }
  const {
    disabled,
    disabledReason: collectionOfferDisabledReason,
    createCollectionOffer
  } = useCollectionOffers(collection, offerCriteria);
  if (disabled) {
    const t3 = !disabled;
    let t4;
    if ($[12] !== t) {
      t4 = t("makeCollectionOffer");
      $[12] = t;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    let t5;
    if ($[14] !== t4 || $[15] !== variant) {
      t5 = <span><Button disabled={true} size="sm" variant={variant}>{t4}</Button></span>;
      $[14] = t4;
      $[15] = variant;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    let t6;
    if ($[17] !== collectionOfferDisabledReason || $[18] !== t3 || $[19] !== t5) {
      t6 = <Tooltip content={collectionOfferDisabledReason} disabled={t3}>{t5}</Tooltip>;
      $[17] = collectionOfferDisabledReason;
      $[18] = t3;
      $[19] = t5;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    return t6;
  }
  const isTraitOffer = Boolean(singleTraitSelected && collection?.traitOffersEnabled) || isTraitOfferValidation;
  if (shouldShowDisabled && disabledReason) {
    let t3;
    if ($[21] !== t) {
      t3 = t("makeTraitOffer");
      $[21] = t;
      $[22] = t3;
    } else {
      t3 = $[22];
    }
    let t4;
    if ($[23] !== t3 || $[24] !== variant) {
      t4 = <span><Button disabled={true} size="sm" variant={variant}>{t3}</Button></span>;
      $[23] = t3;
      $[24] = variant;
      $[25] = t4;
    } else {
      t4 = $[25];
    }
    let t5;
    if ($[26] !== disabledReason || $[27] !== t4) {
      t5 = <Tooltip content={disabledReason}>{t4}</Tooltip>;
      $[26] = disabledReason;
      $[27] = t4;
      $[28] = t5;
    } else {
      t5 = $[28];
    }
    return t5;
  }
  let t3;
  if ($[29] !== createCollectionOffer) {
    t3 = () => {
      createCollectionOffer();
    };
    $[29] = createCollectionOffer;
    $[30] = t3;
  } else {
    t3 = $[30];
  }
  let t4;
  if ($[31] !== isTraitOffer || $[32] !== t) {
    t4 = isTraitOffer ? t("makeTraitOffer") : t("makeCollectionOffer");
    $[31] = isTraitOffer;
    $[32] = t;
    $[33] = t4;
  } else {
    t4 = $[33];
  }
  let t5;
  if ($[34] !== t3 || $[35] !== t4 || $[36] !== variant) {
    t5 = <Button onClick={t3} size="sm" variant={variant}>{t4}</Button>;
    $[34] = t3;
    $[35] = t4;
    $[36] = variant;
    $[37] = t5;
  } else {
    t5 = $[37];
  }
  return t5;
}
function _temp(trait) {
  return {
    traitType: trait.traitType,
    value: trait.values[0]
  };
}